var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sip-view-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm sip-view-head" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("general.support"))),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "admin-status-badge",
            class:
              _vm.product.name && !_vm.checkSupportValidity
                ? "admin-status-badge--danger"
                : "admin-status-badge--success",
          },
          [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.product.name && !_vm.checkSupportValidity
                    ? "Expired"
                    : "Available"
                ) +
                "\n                "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row sip-view-grid" }, [
      _c("div", { staticClass: "col-12 col-lg-8" }, [
        _c("div", { staticClass: "card sip-view-card" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm.product.name && !_vm.checkSupportValidity
              ? _c(
                  "div",
                  { staticClass: "sip-view-note sip-view-note--danger" },
                  [
                    _c("strong", [_vm._v("Your support is expired.")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Please renew your support before opening a new request."
                      ),
                    ]),
                  ]
                )
              : _c("div", [
                  _c("div", {
                    staticClass: "sip-view-rich",
                    domProps: { innerHTML: _vm._s(_vm.support_tips) },
                  }),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "mt-3",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                        keydown: function ($event) {
                          return _vm.supportForm.errors.clear(
                            $event.target.name
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [_vm._v("Subject")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.supportForm.subject,
                                expression: "supportForm.subject",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              value: "",
                              name: "subject",
                              placeholder: "Subject",
                            },
                            domProps: { value: _vm.supportForm.subject },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.supportForm,
                                  "subject",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.supportForm,
                              "prop-name": "subject",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [_vm._v("Body")]),
                          _vm._v(" "),
                          _c("autosize-textarea", {
                            staticClass: "form-control",
                            attrs: {
                              rows: "5",
                              placeholder: "Body",
                              name: "body",
                            },
                            model: {
                              value: _vm.supportForm.body,
                              callback: function ($$v) {
                                _vm.$set(_vm.supportForm, "body", $$v)
                              },
                              expression: "supportForm.body",
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.supportForm,
                              "prop-name": "body",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(1),
                    ]
                  ),
                ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c("div", { staticClass: "card sip-view-card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [_c("product", { attrs: { product: _vm.product } })],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [
        _vm._v("Contact support with product metadata attached automatically."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sip-view-actions" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
          attrs: { type: "submit" },
        },
        [_vm._v("Submit")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }